export enum ExposureConstants {
  SET_CREW_ID = 'exposure/SET_CREW_ID',
  SET_EXPOSURE_EQUIPMENT = 'exposure/SET_EXPOSURE_EQUIPMENT',
  SET_SUSPECTED_EXPOSURE = 'exposure/SET_SUSPECTED_EXPOSURE',
  SET_SUSPECTED_EXPOSURE_PNNV = 'exposure/SET_SUSPECTED_EXPOSURE_PNNV',
  SET_EXPOSURE_TYPE = 'exposure/SET_EXPOSURE_TYPE',
  SET_EXPOSURE_TYPE_PNNV = 'exposure/SET_EXPOSURE_TYPE_PNNV',
  SET_EXPOSED_TO = 'exposure/SET_EXPOSED_TO',
  SET_EXPOSURE = 'exposure/SET_EXPOSURE',
  SET_EXPOSURE_LIST = 'exposure/SET_EXPOSURE_LIST',
  SET_CREW_LIST = 'exposure/SET_CREW_LIST',
  SAVE_EXPOSURE = 'exposure/SAVE_EXPOSURE',
  SET_EXPOSURE_STATE = 'exposure/SET_EXPOSURE_STATE',
  RESET_STATE = 'exposure/RESET_STATE',
}
